import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type LegalModalType = 'rules' | 'policy' | null;

@Injectable({
  providedIn: 'root'
})
export class LegalModalsService {
  private readonly activeModalSubject = new BehaviorSubject<LegalModalType>(null);
  readonly activeModal$ = this.activeModalSubject.asObservable();

  openRules(): void {
    this.activeModalSubject.next('rules');
  }

  openPolicy(): void {
    this.activeModalSubject.next('policy');
  }

  close(): void {
    this.activeModalSubject.next(null);
  }
}
